<h2 class="text-center"> Creating Task Template  {{newTemplateName}}</h2>

<form [formGroup]="myForm" (ngSubmit)="submit()">
  <div  class="form-group row  mt-2">
    <label for="templateName" class="col-sm-2  col-form-label text-end"> Template Name </label>
    <div class="col-sm-8">
      <input
      formControlName="templateName"
      id="templateName"
      type="input"
      (change)="onTemplateNameChange()"
      class="form-control">

    </div>
    </div>
<hr/>
  <div *ngFor = "let part of taskTemplate['parts']; let mainPartIndex= index">
    <div  class="form-group row ms-2 mt-2">
      <div class="col-sm-2 text-end">{{part['name']}}</div>
      <div class="col-sm-2">Name</div>
      <div class="col-sm-2">source</div>
      <div class="col-sm-2">value</div>
      <div class="col-sm-2">valuetype</div>
      <div class="col-sm-1" *ngIf="part['source']=='system'">BM</div>
      <div class="col-sm-1"></div>
    </div>

    <div class="form-group row  mt-2">
      <div class="col-sm-2"></div>
      <div class="col-sm-2">
        <input
        [formControlName]="part['name']"
        [id]="part['name']"
        type="input"
        class="form-control">

      </div>
      <div class="col-sm-2">
          <select class="form-control" id="source"   [formControlName]="part['name']+'_source'" (change)="onChangeMainPartSource(mainPartIndex)">
            <option *ngFor="let source of sources" [value]="source">{{source}}</option>
          </select>
      </div>
      <div class="col-sm-2">
            <input
            [formControlName]="part['name']+'_value'"
            [id]="part['name']+'_value'"
            type="input"
            class="form-control">
      </div>
      <div class="col-sm-2">
              <select class="form-control" [id]="part['name']+'_valuetype'"   [formControlName]="part['name']+'_valuetype'">
                <option *ngFor="let valueType of valueTypes" [value]="valueType">{{valueType}}</option>
              </select>
      </div>
      <div class="col-sm-1" *ngIf="part['source']=='system'">
        <select class="form-control" [id]="part['name']+'_bm'"   [formControlName]="part['name']+'_bm'">
          <option *ngFor="let bm of boldManagers" [value]="bm">{{bm}}</option>
        </select>
      </div>
      <div class="col-sm-1"><button class="btn btn-danger" (click)="removePart(part['name'])" type="button"> <i class="fa fa-minus"></i> {{part['name']}}</button></div>
  </div>

  <div *ngIf="(part['source']=='system') && (part['params'].length>0)">

            <div *ngFor="let param of part['params'];let ccp=index;" class="form-group row ms-2 mt-2">
              <div class="col-sm-2 text-end">param</div>
              <div class="col-sm-2">
                <input
                [formControlName]="param['name']"
                [id]="param['name']"
                type="input"
                class="form-control">

              </div>

              <div class="col-sm-2">
                <select class="form-control" [id]="param['name']+'_source'"   [formControlName]="param['name']+'_source'">
                  <option *ngFor="let source of sources" [value]="source">{{source}}</option>
                </select>
              </div>

              <div class="col-sm-2">
                <input
                [formControlName]="param['name']+'_value'"
                [id]="param['name']+'_value'"
                type="input"
                class="form-control">
              </div>

              <div class="col-sm-2">
                <select class="form-control" [id]="param['name']+'_valuetype'"   [formControlName]="param['name']+'_valuetype'">
                  <option *ngFor="let valueType of valueTypes" [value]="valueType">{{valueType}}</option>
                </select>
              </div>
              <div class="col-sm-2"><button class="btn btn-secondary" (click)="removePartParam(part['name'],param['name'])" type="button">Remove</button></div>
            </div>
          </div>
          <div class="form-group row ms-2 mt-2">
            <div class="col-sm-12 text-end">
            <span *ngIf="part['source']=='system'"><button  class="btn btn-primary me-2" (click)="addMainPartParam(mainPartIndex)" type="button"> <i class="fa fa-plus"></i> Param</button></span>

            </div>
          </div>
    <hr/>
  </div><!-- End of parts-->
  <div class="text-center">
    <button class="btn btn-secondary" (click)="addPartPopUp()" type="button"> <i class="fa fa-plus"></i>  Part</button>
  </div>

  <!--Main Layouts-->
  <div *ngFor = "let layout of taskTemplate['layouts']; let tIndex=index">
    <div  class="form-group row ms-2 mt-2">
      <label [for]="'m'+tIndex+'_topology'" class="col-sm-2  col-form-label  text-end">Topology</label>
      <div class="col-sm-10">
        <select class="form-control" [id]="'m'+tIndex+'_topology'"
        [formControlName]="'m'+tIndex+'_topology'">
          <option *ngFor="let topology of topologies" [value]="topology">{{topology}}</option>
        </select>
      </div>
      </div>
      <div *ngFor = "let body of layout['body']; let bIndex=index">
        <div class="form-group row mt-2">
          <div class="col-sm-3 text-end">body</div>
          <div class="col-sm-8">
            <input
            [formControlName]="'m'+tIndex+'_'+bIndex+'_body'"
            [value]="body"
            [id]="'m'+tIndex+'_'+bIndex+'_body'"
            type="input"
            class="form-control">
          </div>
          <div class="col-sm-1">
            <button class="btn btn-danger" (click)="removeMainBody(tIndex)" type="button"><i class="fa fa-trash"></i></button>
          </div>
      </div>
    </div><!-- end of main body loop-->
      <div class="form-group row mt-2">
        <div class="col-sm-3"></div>
        <div class="col-sm-9 text-center">
          <button class="btn btn-primary me-2" (click)="addMainBody(tIndex)" type="button"> Add Main Body</button>
          <button class="btn btn-secondary" (click)="addMainPresentation(tIndex)" type="button"> Add Main Presentation</button>
        </div>
      </div>
      <div class="form-group row mt-2">
        <div class="col-sm-3"></div>
        <div class="col-sm-3">value</div>
        <div class="col-sm-3">source</div>
        <div class="col-sm-3">value Type</div>

      </div>
      <div class="form-group row">
          <div class="col-sm-3  text-end">Answer</div>
          <div class="col-sm-3">
                <input
                [formControlName]="'m'+tIndex+'_answer_value'"
                [value]="layout['answer']['value']"
                [id]="'m'+tIndex+'_answer_value'"
                type="input"
                class="form-control">
          </div>
          <div class="col-sm-3">
                <select class="form-control" [id]="'m'+tIndex+'_answer_source'"   [formControlName]="'m'+tIndex+'_answer_source'">
                  <option *ngFor="let source of sources" [value]="source">{{source}}</option>
                </select>

          </div>
          <div class="col-sm-3">
                <select class="form-control" [id]="'m'+tIndex+'_answer_valuetype'"   [formControlName]="'m'+tIndex+'_answer_valuetype'">
                  <option *ngFor="let valueType of valueTypes" [value]="layout['answer']['valuetype']">{{valueType}}</option>
                </select>
          </div>

      </div><!--Answer row-->

      <div *ngFor="let presentation of layout['answer']['presentations'];let pIndex=index;">
        <div class="form-group row mt-2">
          <div class="col-sm-3 text-end"> Presentation Type</div>
          <div class="col-sm-6">
            <select class="form-control"
            [id]="'m'+tIndex+'_'+pIndex+'_presentationtype'"
            [formControlName]="'m'+tIndex+'_'+pIndex+'_presentationtype'"
            (change)="onChangeMainPresentationType(tIndex, pIndex)">
              <option *ngFor="let pType of presentationTypes" [value]="pType">{{pType}}</option>
            </select>
          </div>
          <div class="col-sm-3"> <button class="btn btn-primary" (click)="removeMainPresentation(tIndex, pIndex)" type="button"><i class="fa fa-minus"></i> Presentation</button></div>
        </div>

        <div *ngFor="let answerOption  of presentation['answerOptions']; let aIndex=index;">
        <div class="form-group row mt-2">
          <div class="col-sm-3"></div>
          <div class="col-sm-2">value</div>
          <div class="col-sm-2">source</div>
          <div class="col-sm-2">value Type</div>
          <div class="col-sm-2">BM</div>
          <div class="col-sm-1"></div>
        </div>
        <div class="form-group row">
            <div class="col-sm-3  text-end">Answer Options</div>
            <div class="col-sm-2">
                  <input
                  [formControlName]="'m'+tIndex+'_'+pIndex+'_'+aIndex+'_answeroption_value'"
                  [value]="answerOption['value']"
                  [id]="'m'+tIndex+'_'+pIndex+'_'+aIndex+'_answeroption_value'"
                  type="input"
                  class="form-control">
            </div>
            <div class="col-sm-2">
                  <select class="form-control" [id]="'m'+tIndex+'_'+pIndex+'_'+aIndex+'_answeroption_source'"   [formControlName]="'m'+tIndex+'_'+pIndex+'_'+aIndex+'_answeroption_source'">
                    <option *ngFor="let source of sources" [value]="source">{{source}}</option>
                  </select>

            </div>
            <div class="col-sm-2">
                  <select class="form-control" [id]="'m'+tIndex+'_'+pIndex+'_'+aIndex+'_answeroption_valuetype'"   [formControlName]="'m'+tIndex+'_'+pIndex+'_'+aIndex+'_answeroption_valuetype'" >
                    <option *ngFor="let valueType of valueTypes" [value]="valueType" >{{valueType}}</option>
                  </select>
            </div>
            <div class="col-sm-2">
              <select class="form-control" [id]="'m'+tIndex+'_'+pIndex+'_'+aIndex+'_answeroption_bm'"   [formControlName]="'m'+tIndex+'_'+pIndex+'_'+aIndex+'_answeroption_bm'">
                <option *ngFor="let bm of boldManagers" [value]="bm">{{bm}}</option>
              </select>
            </div>
            <div class="col-sm-1"> <button class="btn btn-danger" (click)="removeMainAnswerOption(tIndex, pIndex,aIndex)" type="button"> <i class="fa fa-minus"></i> Option</button></div>
        </div>

        <div *ngIf="answerOption['source']=='system'">
          <div *ngFor="let param of answerOption['params'];let paramIndex=index;" class="form-group row ms-2 mt-2">
            <div class="col-sm-2 text-end">param</div>
            <div class="col-sm-2">
              <input
              [formControlName]="param['name']"
              [id]="param['name']"
              type="input"
              class="form-control">

            </div>

            <div class="col-sm-2">
              <select class="form-control" [id]="param['name']+'_source'"   [formControlName]="param['name']+'_source'">
                <option *ngFor="let source of sources" [value]="source">{{source}}</option>
              </select>
            </div>

            <div class="col-sm-2">
              <input
              [formControlName]="param['name']+'_value'"
              [id]="param['name']+'_value'"
              type="input"
              class="form-control">
            </div>

            <div class="col-sm-2">
              <select class="form-control" [id]="param['name']+'_valuetype'"   [formControlName]="param['name']+'_valuetype'">
                <option *ngFor="let valueType of valueTypes" [value]="valueType">{{valueType}}</option>
              </select>
            </div>
            <div class="col-sm-2"><button class="btn btn-secondary" (click)="removeMainAnswerOptionParam(tIndex, pIndex,aIndex,paramIndex)" type="button">Remove</button></div>
          </div>
          <div class="form-group row mt-2" *ngIf="answerOption['source']=='system'">
            <div class="col-sm -12 text-end">
             <button  class="btn btn-primary me-2" (click)="addMainAnswerOptionParam(tIndex, pIndex,aIndex)" type="button"><i class="fa fa-plus"></i> Param</button>
            </div>

          </div>
        </div>

      </div><!--Answer option for-->
      <div class="form-group row mt-2" *ngIf="presentation['presentationType']=='RADIOGROUP'">
        <div class="col-sm-12 text-center">
           <button class="btn btn-primary" (click)="addMainAnswerOption(tIndex, pIndex)" type="button"> <i class="fa fa-plus"></i> Answer Option({{tIndex}}{{pIndex}})</button>
        </div>
      </div>
      </div><!--end main presentation-->
  </div><!-- end of layout for-->
<!-- End main layout-->


  <fieldset class="text-center mt-4">
    <hr/><hr/>
            <button [disabled]="loading" class="btn btn-primary me-4" type="submit">
                <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span> Submit
            </button>
            <a class="btn btn-secondary" [routerLink]="['/task/template/list']"> Close</a>
  </fieldset>


</form>

<app-task-part-modal [newTemplateName]="newTemplateName"
(partSourceEvent)="partSourceGiven($event)"
(closeModalRequest)="closeModal()">
</app-task-part-modal>



